import { INFLUENCER_SIGNUP_CATEGORIES } from './marketplaceCategories';

export { INFLUENCER_SIGNUP_CATEGORIES } from './marketplaceCategories';

/** Same 20 labels as campaign create / marketplace filters. */
export const CONTENT_CATEGORIES = INFLUENCER_SIGNUP_CATEGORIES;

export const FEE_MODELS = [
  'commission',
  'flat',
  'hourly',
];

export { default as US_STATES } from './usStates';

/** Creator handle fields — keep in sync with influencers table columns and onboarding/profile forms. */
export const INFLUENCER_PLATFORM_HANDLE_FIELDS = Object.freeze([
  { key: 'tiktokHandle', label: 'TikTok username', platform: 'TikTok' },
  { key: 'instagramHandle', label: 'Instagram username', platform: 'Instagram' },
  { key: 'whatnotHandle', label: 'Whatnot username', platform: 'Whatnot' },
]);

export function sanitizeInfluencerHandle(value) {
  if (typeof value !== 'string') return '';
  return value.startsWith('@') ? value.substring(1) : value;
}

export function derivePlatformTypesFromHandles(formData = {}) {
  return INFLUENCER_PLATFORM_HANDLE_FIELDS
    .filter(({ key }) => String(formData[key] || '').trim())
    .map(({ platform }) => platform);
}
